import _ from 'lodash';
import Cognito from '../../../../global/js/cognito';

export class VerifyAccountModal {
	constructor(options) {
		this.options = _.merge({}, options);
		// Load template
		this.template = $('#VerifyAccountModal').html();
		// Initialize User Pool
		this.userPool = Cognito.getUserPool({
			UserPoolId: window.cognitoUserPoolId,
			ClientId: window.cognitoAppClientId,
		});

		this.cognitoUser = null;
		this.$modal = null;
		this.$serverError = null;
		this.$btnVerify = null;
		this.email = '';
	}

	init() {
		this.open();
		this.addEventHandler();
		this.setupVerifyAccountProcess();
	}

	open() {
		this.$modal = $('[data-role="verify-account-modal"]');
		if (this.$modal.length) {
			this.$modal.removeClass('hidden');
		} else {
			$('body').append(this.template);
			this.$modal = $('[data-role="verify-account-modal"]');
			setTimeout(()=> {
				this.$modal.removeClass('hidden');
			}, 300);
		}
		this.$serverError = this.$modal.find('.server-error');
		this.$btnVerify = this.$modal.find('.btn-login');
	}

	close() {
		if (this.$modal && this.$modal.length) {
			this.$modal.addClass('hidden');

			// Reset style
			this.$modal.find('.form-group').removeClass('error');
			this.$modal.find('input').val('');
			this.$modal.find('.error').html('');
			this.$serverError.html('');
		}
	}

	addEventHandler() {
		if (!this.$modal || !this.$modal.length) return;

		this.$modal
			.off('click.close')
			.on('click.close', '.popup-close', (e)=> {
				e.preventDefault();
				this.close();
			});

		this.$modal
			.off('click.send')
			.on('click.send', '.btn-verify', (e)=> {
				e.preventDefault();
				const code = this.$modal.find('#code').val();
				if (!this.cognitoUser) this.cognitoUser = Cognito.getCognitoUser(null, this.userPool);
				this.$btnVerify.prop('disabled', true);
				this.verifyEmail(code)
					.then((result)=>{
						this.$btnVerify.prop('disabled', false);
						this.close();
						if (typeof this.options.onVerified === 'function') this.options.onVerified(result);
					}, (err)=> {
						this.$serverError.html(`<span>${err.message}</span>`);
					});
			});

		this.$modal
			.off('click.sendagain')
			.on('click.sendagain', '.btn-send-again', (e)=> {
				e.preventDefault();
				this.sendVerifyCode();
			});
	}

	/**
	 * Set up verification process for the modal.
	 */
	setupVerifyAccountProcess() {
		this.$btnVerify.prop('disabled', true);
		Cognito.getUserAttributes(this.userPool)
			.then((userAttrs)=> {
				this.sendVerifyCode()
					.then((result)=> {
						const emailAttr = _.find(userAttrs, {Name: 'email'});
						this.email = emailAttr.getValue();
						this.$modal.find('.user-email').html(this.email);

						this.$modal.find('.success-request').removeClass('d-none');
						this.$serverError.html('');
						this.$btnVerify.prop('disabled', false);
					}, (err)=> {
						this.$modal.find('.success-request').addClass('d-none');
						this.$serverError.html(`<span>${err.message}</span>`);
					});
			}, (err)=> {
				this.$modal.find('.success-request').addClass('d-none');
				this.$serverError.html(`<span>${err.message}</span>`);
			});
	}

	/**
	 * Send a verification code email.
	 */
	sendVerifyCode() {
		return new Promise((resolve, reject)=> {
			this.cognitoUser = Cognito.getCognitoUser(null, this.userPool);
			if (this.cognitoUser) {
				this.cognitoUser.getSession((err, session)=>{
					this.cognitoUser.getAttributeVerificationCode('email', {
						onSuccess: (result)=>{
							resolve(result);
						},
						onFailure: (err)=>{
							reject(err);
						},
					});
				});
			}
		});
	}

	/**
	 * Send verification code to server.
	 */
	verifyEmail(code) {
		return new Promise((resolve, reject)=> {
			if (!this.cognitoUser) reject({message: 'Cannot get user.'});
			this.cognitoUser.verifyAttribute('email', code, {
				onSuccess: (result)=>{
					resolve(result);
				},
				onFailure: (err)=>{
					reject(err);
				},
			});
		});
	}
}
